import React from 'react';
import PropTypes from 'prop-types';
import CopyButton from '../../../../components/CopyButton/CopyButton';
import {
  Container,
  TopRow,
  BrandBadge,
  SeasonBadge,
  Title,
  CatalogRow,
  CatalogNumber,
  Headline,
} from './TyreHeader.style';

const getSeasonIcon = (season) => {
  if (!season) return 'mdi-weather-cloudy';
  const seasonLower = season.toLowerCase();
  if (seasonLower.includes('winter') || seasonLower === 'wi') return 'mdi-snowflake';
  if (seasonLower.includes('summer') || seasonLower === 'su' || seasonLower === 'scck') return 'mdi-white-balance-sunny';
  if (seasonLower.includes('all') || seasonLower === 'as') return 'mdi-weather-partly-cloudy';
  return 'mdi-weather-partly-cloudy';
};

const getSeasonKey = (season) => {
  if (!season) return null;
  const seasonMap = {
    'scck': 'summer',
    'SU': 'summer',
    'SUMMER': 'summer',
    'WI': 'winter',
    'WINTER': 'winter',
    'AS': 'allSeason',
    'ALL_SEASON': 'allSeason',
  };
  
  return seasonMap[season.toUpperCase()] || null;
};

const TyreHeader = ({productName, brand, catalogNumber, headline, season}) => {
  const seasonKey = getSeasonKey(season);
  const seasonLabels = {
    'winter': 'Zima',
    'summer': 'Poletje',
    'allSeason': 'Vsi letni časi'
  };
  
  return (
    <Container>
      <TopRow>
        {brand && <BrandBadge>{brand}</BrandBadge>}
        {season && (
          <SeasonBadge season={season}>
            <i className={`mdi ${getSeasonIcon(season)}`} />
            {seasonKey ? seasonLabels[seasonKey] || season : season}
          </SeasonBadge>
        )}
      </TopRow>
      <Title>{productName || catalogNumber}</Title>
      <CatalogRow>
        <CatalogNumber>Kataloška št.: {catalogNumber}</CatalogNumber>
        <CopyButton text={catalogNumber} compact />
      </CatalogRow>
      {headline && <Headline>{headline}</Headline>}
    </Container>
  );
};

TyreHeader.propTypes = {
  productName: PropTypes.string,
  brand: PropTypes.string,
  catalogNumber: PropTypes.string.isRequired,
  headline: PropTypes.string,
  season: PropTypes.string,
};

export default TyreHeader;
